module.exports = __webpack_public_path__ + "static/img/toRight-icon.58572e0f.svg";